import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// @tanstack/react-query used to wrap the app here, but nothing in the
// codebase actually uses useQuery/useMutation — every page fetches via
// lib/api.js + useEffect/useCallback instead, so the provider (and the
// dependency itself) was dead weight on every single page load.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
